import React from 'react';
import { Loader } from 'semantic-ui-react';

export default class ContentLoader extends React.Component {
  render() {
    return (
      <div style={{ padding: '4em', margin: '0 auto' }}>
        <Loader active inline='centered' />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Elements/Loader/Loader.js